/**
 * Shared copy for public portal token UX (ZRF-WTPB-009).
 * Invalid/expired/revoked messages stay generic — no PII.
 */

export const PORTAL_LINK_UNAVAILABLE =
  'This secure link is no longer available. Please contact your landlord for a new link.';

export const PORTAL_CONSENT_FOOTER =
  'This secure ZenRentFlow link was shared by your landlord/property manager to help manage rental communication, maintenance, documents, and access confirmations. Your submissions may be stored as part of the property record.';

/**
 * @param {{ valid?: boolean, reason?: string, actionType?: string, error?: { message?: string } }} payload
 * @param {{ requiredActionType?: string }} [opts]
 */
export function portalTokenErrorMessage(payload, opts = {}) {
  if (!payload || payload.valid === false) {
    return (payload && payload.error && payload.error.message) || PORTAL_LINK_UNAVAILABLE;
  }
  if (opts.requiredActionType && payload.actionType && payload.actionType !== opts.requiredActionType) {
    return PORTAL_LINK_UNAVAILABLE;
  }
  return null;
}

export const MAINTENANCE_CATEGORIES = [
  { value: 'plumbing', label: 'Plumbing' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'hvac', label: 'Heating / Cooling' },
  { value: 'appliance', label: 'Appliance' },
  { value: 'structural', label: 'Structural / Doors / Windows' },
  { value: 'pest', label: 'Pest' },
  { value: 'other', label: 'Other' },
];

export const MAINTENANCE_URGENCIES = [
  { value: 'low', label: 'Low — can wait' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High — soon' },
  { value: 'emergency', label: 'Emergency — safety or major damage' },
];
